// The hyphen being outside the class is what rejects a business ID ("2081088-7") typed as an address.
const EINVOICE_ADDRESS_SHAPE_PATTERN = /^[A-Za-z0-9]{9,21}$/;
const MIN_DIGIT_COUNT = 6;

// Gates new keystrokes only — NOT a form validator. Values already in the form are grandfathered.
export const isCommittableEinvoiceAddress = (rawValue: string): boolean => {
    const trimmed = rawValue.trim();

    if (trimmed === '') {
        return false;
    }

    if (!EINVOICE_ADDRESS_SHAPE_PATTERN.test(trimmed)) {
        return false;
    }

    const digitCount = (trimmed.match(/\d/g) ?? []).length;
    return digitCount >= MIN_DIGIT_COUNT;
};
